/**
 * ListGridView - Card image grid of list entries
 */
import type { ReactElement } from 'react';

import type { CardGroup } from '@/lib/cardGrouping';
import type { EnrichedListCard } from '@/types/lists';

import ListGridCard from './ListGridCard';

export interface ListGridViewProps {
  groups: CardGroup<EnrichedListCard>[];
  showGroupHeaders: boolean;
  isPending: (cardId: string) => boolean;
  onIncrease: (card: EnrichedListCard) => void;
  onDecrease: (card: EnrichedListCard) => void;
  onRemove: (card: EnrichedListCard) => void;
  onOpenDetails: (card: EnrichedListCard) => void;
}

export default function ListGridView({
  groups,
  showGroupHeaders,
  isPending,
  onIncrease,
  onDecrease,
  onRemove,
  onOpenDetails,
}: ListGridViewProps): ReactElement {
  return (
    <div className="space-y-8">
      {groups.map((group) => (
        <section key={group.key}>
          {showGroupHeaders && (
            <h3 className="mb-3 border-b border-zinc-800 pb-1 text-xs font-medium tracking-wide text-zinc-400 uppercase">
              {group.label} <span className="text-zinc-600">({group.cards.length})</span>
            </h3>
          )}
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6">
            {group.cards.map((card) => (
              <ListGridCard
                key={card.id}
                card={card}
                isPending={isPending(card.id)}
                onIncrease={() => onIncrease(card)}
                onDecrease={() => onDecrease(card)}
                onRemove={() => onRemove(card)}
                onOpenDetails={() => onOpenDetails(card)}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
